<div class="admin-layout">
  <div class="admin-panels">
    <div class="panel-container">
      <div class="letter-management">
        <h2>letter management</h2>

        <div kendoWindowContainer></div>

        <kendo-grid [data]="gridData">
          <kendo-grid-column
          *ngIf="operatingMode === 'Taranto'"
            field="letterId"
            title="ID"
            width="200"
            [headerStyle]="{ padding: '10px' }"
          >
          </kendo-grid-column>
          <kendo-grid-column
            field="saved"
            width="220"
            title="date/time"
            [headerStyle]="{ padding: '10px' }"
            [headerClass]="'tableRow'"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.saved + 'Z' | date: 'dd-MMM-yy HH:mm:ss' }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="pcn"
            title="PCN"
            width="200"
            [headerStyle]="{ padding: '10px' }"
          >
            <!-- <ng-template #rmLetter kendoGridCellTemplate let-dataItem>
              <ng-template #rmLetter>
                <div [innerHTML]="dataItem.letterHtml"></div>
              </ng-template>
              <button kendoGridEditCommand class="btn-retry" (click)="showLetter(dataItem)">
                {{ dataItem.pcn }}
              </button>
            </ng-template> -->
            <ng-template #rmLetter kendoGridCellTemplate let-dataItem>
              <ng-template #rmLetter>
                <div [innerHTML]="letterContent"></div>
              </ng-template>
              <button kendoGridEditCommand class="btn-retry" (click)="showLetter(rmLetter,dataItem)">
                {{ dataItem.pcn }}
              </button>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="status"
            title="status"
            width="200"
            [headerStyle]="{ padding: '10px' }"
          >  
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ operatingMode === 'Taranto' ? dataItem.status : 'saved' }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
          *ngIf="operatingMode === 'Taranto'"
            field="statusMessage"
            title="status message"
            width="200"
            [headerStyle]="{ padding: '10px' }"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.statusMessage }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-command-column
          *ngIf="operatingMode === 'Taranto'"
            field="retryUpload"
            title="retry"
            width="200"
            [headerStyle]="{ padding: '10px' }"
          >
            <ng-template kendoGridCellTemplate let-dataItem *ngIf="operatingMode === 'Taranto'">

              <div *ngIf="dataItem.status !== 'Sent'">
                <button
                  kendoGridEditCommand
                  class="btn-retry"
                  (click)="RetryLetter(dataItem.letterId)"
                >
                  retry
                </button>

                <div *ngIf="dataItem.status === 'Sent'">
                  <ng-template>Uploaded</ng-template>
                </div>
              </div>
            </ng-template>
          </kendo-grid-command-column>
        </kendo-grid>
        <div class="btn app-submit" (click)="RetryAllTodaysLettersForUser()" *ngIf="operatingMode === 'Taranto'">retry all letters</div>
      </div>
    </div>
  </div>
</div>
